exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".colour-pick{margin-bottom:40px}.colour-pick .vue-swatches__trigger{margin-bottom:10px}.colour-pick .vue-swatches__fallback__wrapper{margin-top:5px}.colour-pick .vue-swatches__fallback__wrapper .vue-swatches__fallback__button{height:20px;border-radius:5px;border:none;width:18%;height:40px;vertical-align:middle}.colour-pick .vue-swatches__fallback__wrapper .vue-swatches__fallback__input--wrapper input{border-radius:5px;border:none;width:80%;height:40px;vertical-align:middle}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-618569ad","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Form/ColourPicker.vue
// module id = 591
// module chunks = 0